<template>
  
  <div class="column" style="position: relative">
    <!-- image -->
    <div @click="click()" v-if="image" style="border-radius: 200px; position: relative; background-size: cover; background-position: center; background-repeat: no-repeat; background-color: var(--back);" :style="{width, height, backgroundImage: `url(${image})`}"></div>

    <!-- letter -->
    <div @click="click()" class="column center" v-else style="border-radius: 200px; color: white; background-color: #222222;" :style="{width, height}">{{ letter }}</div>

    <!-- online -->
     <div v-if="online" :style="{width: onlineSize, height: onlineSize}" style="position: absolute; top: 0; right: -0px; background-color: var(--online);border-radius: 200px;"></div>
    
</div>
    
</template>
<script>

/*

    <avatar :image="image" online name="james"/>
 
*/

export default {
    data: function () {return {
        
    }},
    props:{
        width:{type:String, default:'37px'},
        height:{type:String, default:'37px'},
        image: String,
        name: String,
        online: Boolean, 
        onlineSize: {type: String, default:'8px'}, 
    },
    
    computed:{
        letter(){
            if (!this.name) return 'S'
            let letter = this.name[0]
            return letter.toUpperCase()
        },        
    },
    methods: {
        click(){
            this.$emit('click');
        },
        
        
    },
}
</script>

<style scoped>

</style>

